import settings from '../virtuoso/settings';
import ApiUtils from '../virtuoso/ApiUtils';
import {ContentIEPRequest} from '../virtuoso/request';
import Lsettings from '../liferay/settings';
import LApiUtils from '../liferay/ApiUtils';

/** Специальные действия для получения информации о wiki страницах
 * Например, список нодов, вложенных страниц
 */
export const IEPActions = {
  EMPTY: () => ({
    type: "IEPActions.EMPTY"
  }),
  LOAD_CONTENT_STARTED: () => ({
    type: "IEPActions.LOAD_CONTENT_STARTED"
  }),
  LOAD_CONTENT_ERROR: (error) => ({
    type: "IEPActions.LOAD_CONTENT_ERROR",
    error,
  }),
  LOAD_CONTENT_OK: (images, wsdl, xsd) => ({
    type: "IEPActions.LOAD_CONTENT_OK",
    images, wsdl, xsd
  }),

// Загрузить содержимое пакета информационного обмена 
// graph - граф, в котором содержится ЕМД
// endpoint - указывает точку, в которой содержится граф с ЕМД
loadContent: (graph) => dispatch => {
    //console.log('initialization', table);
    //Сделаем событие, что начали загружать данные 
    dispatch(IEPActions.LOAD_CONTENT_STARTED());
    const options = {...settings.options};
    ContentIEPRequest.setGraph(graph);
    return ApiUtils.query(ContentIEPRequest, {}, options)
        .then(response => { 
            //console.log("EMDActions.js loadContent", response);
            dispatch(IEPActions.LOAD_CONTENT_OK(response, response, response));
            return response;
        })
        .catch(e => { 
            console.error(new Error("cannot load content IEP graph",e)); 
            dispatch(EMDActions.LOAD_CONTENT_ERROR());
            return Promise.reject(e);
        });
  },

};
